import { AsyncPipe, CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SnackbarService } from '@app/core/services/snack-bar.service';
import { IdentityProvider } from '@app/preferences/models/identity-provider.model';
import { IdentityProviderService } from '@app/preferences/services/identity-provider.service';
import { AssetUrlPipe } from '@app/shared/pipes/asset-url.pipe';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-identity-providers',
  standalone: true,
  imports: [
    AsyncPipe,
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatDividerModule,
    TranslateModule,
    AssetUrlPipe,
  ],
  templateUrl: './identity-providers.component.html',
  styleUrls: ['./identity-providers.component.scss'],
})
export class IdentityProvidersComponent implements OnInit {
  protected readonly providers$ = this.identityProviderService.identityProviders$;
  protected readonly isLoading$ = this.identityProviderService.isLoading$;

  constructor(
    private identityProviderService: IdentityProviderService,
    private snackbarService: SnackbarService,
    private translateService: TranslateService
  ) {}

  public ngOnInit(): void {
    this.identityProviderService.ensureProvidersLoaded();
  }

  protected getProviderIcon(provider: IdentityProvider): string {
    const name = provider.identity_provider_name.toLowerCase();
    if (name.includes('microsoft')) {
      return 'assets/microsoftM.png';
    }
    if (name.includes('google')) {
      return 'assets/googleG.png';
    }
    return '';
  }

  protected async removeProvider(provider: IdentityProvider): Promise<void> {
    try {
      await this.identityProviderService.removeProvider(
        provider.identity_provider_id,
        provider.identity_provider_user_id
      );
    } catch {
      this.snackbarService.open(this.translateService.instant('INTEGRATIONS_PREFERENCES.REMOVE_PROVIDER_ERROR'));
    }
  }
}
